<script setup lang="ts">
import StatBlock from "@/components/modules/Analytics/Charts/StatBlock.vue";
import DynamicByMonth from "@/components/modules/Analytics/Charts/DynamicByMonth.vue";
import RegionTop from "@/components/modules/Analytics/Charts/RegionTop.vue";
import {OvertimeCasesAnalyticProps} from "@/types/analytics";

defineProps<OvertimeCasesAnalyticProps>();
</script>

<template>
  <div class="params">
    <div class="params__wrapper">
      <StatBlock
        title="окончено дел с нарушением сроков"
        :value="analyticData.totalData?.completed_overtime?.value"
        :percent="analyticData.totalData?.completed_overtime?.percent_to_previous"
        :is-appg="false"
        :is-main="true"
      />
      <StatBlock
        title="из них из числа ранее приостановленных"
        :value="analyticData.totalData?.resumed_from_suspended?.value"
        :percent="analyticData.totalData?.resumed_from_suspended?.percent_to_previous"
        :is-appg="true"
      />
    </div>

    <StatBlock
      title="удельный вес от числа направленных прокурору, в суд и прекращенных (за исключением возобновленных)"
      :value="analyticData.totalData?.percent_overtime_excluding_resumed?.value"
      :percent="analyticData.totalData?.percent_overtime_excluding_resumed?.percent_to_previous"
      :is-appg="true"
    />

    <DynamicByMonth
      :active-type="activeType"
      :selected-region="selectedRegion"
      :selected-district="selectedDistrict"
      :dynamic="analyticData.monthlyDynamic"
    />
    <template v-if="activeType !== 'region'">
      <RegionTop
        sort-order="desc"
        :active-type="activeType"
        :selected-district="selectedDistrict"
        :region-list="analyticData.topDescending"
      />
      <RegionTop
        sort-order="asc"
        :active-type="activeType"
        :selected-district="selectedDistrict"
        :region-list="analyticData.topAscending"
      />
    </template>
  </div>
</template>

<style scoped lang="scss">
.params {
  display: flex;
  flex-direction: column;
  gap: 12px;
  height: 100%;

  &__wrapper {
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-gap: 12px;
    margin-top: auto;
  }
}
</style>